import { defineMessages } from 'react-intl'

const scope = `procurify.modules.expense.features.list-approved-expense-items.ApprovedExpenseItemListPresenter`

export default defineMessages({
  savedFiltersLabel: {
    id: `${scope}.savedFiltersLabel`,
    defaultMessage: 'Saved filters',
  },
  primaryCategoryFilterLabel: {
    id: `${scope}.primaryCategoryFilterLabel`,
    defaultMessage: '{singularPrimaryOrgCategoryLabel}',
  },
  secondaryCategoryFilterLabel: {
    id: `${scope}.secondaryCategoryFilterLabel`,
    defaultMessage: '{singularSecondaryOrgCategoryLabel}',
  },
  requesterFilterLabel: {
    id: `${scope}.requesterFilterLabel`,
    defaultMessage: 'Requester',
  },
  submittedDateRangeFilterLabel: {
    id: `${scope}.submittedDateRangeFilterLabel`,
    defaultMessage: 'Submitted date range',
  },
  approvedDateRangeFilterLabel: {
    id: `${scope}.approvedDateRangeFilterLabel`,
    defaultMessage: 'Approved date range',
  },
  clearFiltersButton: {
    id: `${scope}.clearFiltersButton`,
    defaultMessage: 'Clear filters',
  },
  fetchErrorTitle: {
    id: `${scope}.fetchErrorTitle`,
    defaultMessage: 'Error',
  },
  fetchErrorMessage: {
    id: `${scope}.fetchErrorMessage`,
    defaultMessage: 'Failed to fetch approved expense items',
  },
})
